<nav id="topmenu" #topmenu *ngIf="!sharedDataService.isAppWebView()" class="navbar navbar-expand-lg navbar-light"
  [ngClass]="{'navbar-open': isnavbar,'topmenu-no-margin': hasWellnessMembership}">

  <div class="navbar-header">
    <a class="navbar-brand" (click)="navigateToHome()">
      <!-- <img width="46" src="{{ headerLogo }}" class="primary-logo d-none d-sm-block"
        alt="WOW LOGO" /> -->
      <img [width]="headerLogoWidthMob" src="{{ headerLogoMob }}" class="primary-logo d-sm-none" (click)="navclose()"
        alt="WOW LOGO" />
    </a>
    @if(!isAuthPage){
    <div class="d-flex align-items-center gap-1">
      <div class="phone-container">

        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24" fill="none">
          <mask id="mask0_3758_5764" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="3" y="3" width="18"
            height="18">
            <path
              d="M19.2193 15.2695L16.6793 14.9795C16.0693 14.9095 15.4693 15.1195 15.0393 15.5495L13.1993 17.3895C10.3693 15.9495 8.0493 13.6395 6.6093 10.7995L8.4593 8.94953C8.8893 8.51953 9.0993 7.91953 9.0293 7.30953L8.7393 4.78953C8.6193 3.77953 7.7693 3.01953 6.7493 3.01953H5.0193C3.8893 3.01953 2.9493 3.95953 3.0193 5.08953C3.5493 13.6295 10.3793 20.4495 18.9093 20.9795C20.0393 21.0495 20.9793 20.1095 20.9793 18.9795V17.2495C20.9893 16.2395 20.2293 15.3895 19.2193 15.2695Z"
              fill="black" />
          </mask>
          <g mask="url(#mask0_3758_5764)">
            <rect width="24" height="24" fill="#191919" />
            <rect width="24" height="24" [style.fill]="phoneFiller" />
          </g>
        </svg>

        <p>{{headerPhoneNumber}}</p>
      </div>
      <!-- <ul class="navbar-nav Em-main-mobile-ul bg-transparent">
        <li class="nav-item En-li dropdown" class="nav-item dropdown border-0 " routerLinkActive="active">

          <a class="nav-link phone-btn dropdown-toggle " href="#" id="navbarDropdown" role="button"
            data-bs-toggle="dropdown" aria-expanded="false">
            <span>
              <img width="17" [src]="sharedService.imagesUrl +  'icons/En.svg'" alt="DOWN ARROW">
              <span>{{currentLanguage.toUpperCase()}}</span>
            </span>
          </a>
          <ul class="dropdown-menu   bordered-menu-en" aria-labelledby="navbarDropdown">

            <li>
              <a class="dropdown-item En-btn" (click)="setLanguage( 'en')">English (EN)</a>
            </li>
            <li class="center-li" routerLinkActive="active"><a class="dropdown-item En-btn" [routerLink]=""
                (click)="setLanguage('es')">Spanish (ES)
              </a></li>
            <li class="border-0 end-li" routerLinkActive="active">
              <a class="dropdown-item En-btn" [routerLink]="" (click)="setLanguage('zh'); navclose()">
                Chinese (ZH)

              </a>
            </li>
          </ul>
        </li>
      </ul> -->

      <!-- @if(isUser) {  -->
      <button (click)="toggleNavbar()" *ngIf="!sharedService.hideburgerMenu" class="navbar-toggler pt-0" type="button"
        aria-controls="navbarSupportedContent" [attr.aria-expanded]="isnavbar" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon-custom" [class.active]="isnavbar"></span>
      </button>
      <!-- } -->
    </div>
    }
  </div>
  <div class="container">
    <a class="navbar-brand main-brand" (click)="navigateToHome()">
      <img [width]="headerLogoWidth" src="{{ headerLogo }}" class="primary-logo d-none d-sm-block" alt="WOW LOGO" />
      <!-- <img width="72" src="{{ sharedService.imagesUrl }}" class="primary-logo d-sm-none"
        alt="WOW LOGO" /> -->
    </a>
    <button (click)="toggleNavbar()" *ngIf="!sharedService.hideburgerMenu" class="navbar-toggler hide-toggler"
      type="button" aria-controls="navbarSupportedContent" [attr.aria-expanded]="isnavbar"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon-custom" [class.active]="isnavbar"></span>
    </button>

    <!-- data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" -->
    @if(!sharedService.removeNavbarLinks){
    <div class="collapse navbar-collapse" [class.show]="isnavbar" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0" [class]="isUser? 'menu-one' :''">

      </ul>
      <ul class="navbar-nav mb-2 mb-lg-0 menu-two">
        @if (!isAuthPage&&headerPhoneNumber) {
        <li class="nav-item">
          <div class="dynamic-phone-number">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <mask id="mask0_3758_5766" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="3" y="3" width="18"
                height="18">
                <path
                  d="M19.2193 15.2695L16.6793 14.9795C16.0693 14.9095 15.4693 15.1195 15.0393 15.5495L13.1993 17.3895C10.3693 15.9495 8.0493 13.6395 6.6093 10.7995L8.4593 8.94953C8.8893 8.51953 9.0993 7.91953 9.0293 7.30953L8.7393 4.78953C8.6193 3.77953 7.7693 3.01953 6.7493 3.01953H5.0193C3.8893 3.01953 2.9493 3.95953 3.0193 5.08953C3.5493 13.6295 10.3793 20.4495 18.9093 20.9795C20.0393 21.0495 20.9793 20.1095 20.9793 18.9795V17.2495C20.9893 16.2395 20.2293 15.3895 19.2193 15.2695Z"
                  fill="black" />
              </mask>
              <g mask="url(#mask0_3758_5766)">
                <rect width="24" height="24" fill="#191919" />
                <rect width="24" height="24" [style.fill]="phoneFiller" />
              </g>
            </svg>
          </div>
          <a class="nav-link dynamic-phone-number" [href]="phoneHref" (click)="navclose()">
            <!-- <img [src]="sharedService.imagesUrl +  'icons/phone-icon-nav-update.svg'" alt="" /> -->
            {{ headerPhoneNumber }}
          </a>
        </li>
        }

        @if(!isLoginPage && !isRegisterPage){
        @if(isUser){
        <!-- <ul class="navbar-nav Em-main-ul">
          <li routerLinkActive="active" class=" nav-item dropdown En-li  En-main " id="main_EN"
            routerLinkActive="active">
            <a routerLinkActive="active" class="nav-link phone-btn dropdown-toggle" href="#" id="navbarDropdown"
              role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <span>
                <img width="17" [src]="sharedService.imagesUrl +  'icons/En.svg'" alt="DOWN ARROW">
                <span>{{currentLanguage.toUpperCase()}}</span>
              </span>
            </a>
            <ul class="dropdown-menu   bordered-menu-en" aria-labelledby="navbarDropdown">
              <div class="menu-mobile-btn-container">
              </div>
              <li>
                <a class="dropdown-item En-btn " (click)="setLanguage('en'); navclose()">English (EN)</a>
              </li>
              <li class="center-li" routerLinkActive="active"><a class="dropdown-item En-btn" [routerLink]=""
                  (click)="setLanguage('es'); ">Spanish (ES)
                </a></li>
              <li class="border-0 end-li" routerLinkActive="active">
                <a class="dropdown-item En-btn" [routerLink]="" (click)="setLanguage('zh'); navclose()">
                  Chinese (ZH)

                </a>
              </li>
            </ul>
          </li>
        </ul> -->
        <li class="nav-item dropdown myaccountmenuli">
          <a class="nav-link dropdown-toggle myaccountmenu" href="#" id="navbarDropdown" role="button"
            data-bs-toggle="dropdown" aria-expanded="false">
            <span class="account-circle-parent">
              <span class="account-circle">{{ userInitials }}</span>
              {{ 'MENU.ACCOUNT' | translate }}
            </span>

          </a>
          <ul class="dropdown-menu bordered-menu" aria-labelledby="navbarDropdown">
            <div class="menu-mobile-btn-container">
              <button>
                <img width="17" [src]="sharedService.imagesUrl +  'icons/dropdown-arrow.svg'" alt="DOWN ARROW">
              </button>
              <button>
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                  <path
                    d="M17.8071 7.47668C17.9019 7.38204 18.065 7.38198 18.1597 7.47668C18.2542 7.57141 18.2543 7.73452 18.1597 7.82922L7.3335 18.6564L7.32764 18.6622L7.32178 18.6691C7.29153 18.7015 7.2321 18.7306 7.15674 18.7306C7.09236 18.7305 7.03213 18.7075 6.98096 18.6564C6.88622 18.5616 6.88622 18.3986 6.98096 18.3038L17.8071 7.47668Z"
                    fill="#494949" stroke="#494949" />
                  <path
                    d="M18.0403 19.2889C17.8503 19.2889 17.6603 19.2189 17.5103 19.0689L6.57004 8.1265C6.28004 7.8365 6.28004 7.3565 6.57004 7.0665C6.86004 6.7765 7.34004 6.7765 7.63004 7.0665L18.5703 18.009C18.8603 18.299 18.8603 18.7789 18.5703 19.0689C18.4203 19.2189 18.2303 19.2889 18.0403 19.2889Z"
                    fill="#494949" />
                </svg>
              </button>
            </div>
            <li><a class="dropdown-item" [routerLink]="routes.account">{{'MENU.ACCOUNT' | translate }}</a></li>
            <li><a class="dropdown-item" [routerLink]="routes.familyInfo">{{ 'MENU.FAMILY' | translate }}</a></li>
            <li><a class="dropdown-item" [routerLink]="routes.wallet">{{ 'MENU.Wallet' | translate }}</a></li>
            <li class="hideonmobile">
              <a class="dropdown-item d-flex align-items-center" [routerLink]="routes.dashboard">
                {{ 'MENU.Dashboard' | translate }} &nbsp;
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                  <path
                    d="M14.19 0.65625H5.81C2.17 0.65625 0 2.82625 0 6.46625V14.8363C0 18.4862 2.17 20.6562 5.81 20.6562H14.18C17.82 20.6562 19.99 18.4862 19.99 14.8463V6.46625C20 2.82625 17.83 0.65625 14.19 0.65625ZM15.25 10.9862C15.25 11.3962 14.91 11.7362 14.5 11.7362C14.09 11.7362 13.75 11.3962 13.75 10.9862V7.96625L6.03 15.6863C5.88 15.8363 5.69 15.9062 5.5 15.9062C5.31 15.9062 5.12 15.8363 4.97 15.6863C4.68 15.3963 4.68 14.9163 4.97 14.6263L12.69 6.90625H9.67C9.26 6.90625 8.92 6.56625 8.92 6.15625C8.92 5.74625 9.26 5.40625 9.67 5.40625H14.5C14.91 5.40625 15.25 5.74625 15.25 6.15625V10.9862Z"
                    fill="black" />
                </svg>
              </a>
            </li>
            <li class="hideonmobile"><a class="dropdown-item" (click)="helperService.logoutFlow()"
                style="color: #ff3232">{{ 'MENU.LOGOUT'
                | translate }}</a></li>
          </ul>
        </li>
        }
        }
      </ul>
      <ul class="navbar-nav mb-2 mb-lg-0 menu-three" [class.mobile-menu]="!isUser">
        @if(!isUser && config && !isAuthPage){
        @if(config.secondaryButtonLink){
        @if( !config.isSecondaryButtonDesign){
        <li class="nav-item topbar-btn">
          <a [routerLink]="config.secondaryButtonLink" class="btn btn-primary-clean" style="margin-right: 4px;text-align: center;">{{
            config.secondaryButtonText
            }}</a>
        </li>
        }
        @else{
        <li class="nav-item topbar-btn">
          <a [routerLink]="config.secondaryButtonLink" class="btn btn-secondary-transparent" style="margin-right: 4px;"
            [class.btn-secondary-scorlled]="isScrolled || !isUser">
            {{
            config.secondaryButtonText
            }}</a>
        </li>
        }
        }
        <!-- @if(config.primaryButtonLink){
        <li class="nav-item topbar-btn">
          <a [routerLink]="config.primaryButtonLink" class="btn btn-primary primary-color">{{
            config.primaryButtonText }}</a>
        </li>
        } -->

        @if(config.primaryButtonLink){
        <li class="nav-item topbar-btn">
          <a (click)="primaryButtonClick(config.primaryButtonLink)" class="btn" [ngClass]="{
                'btn-primary': !isAcaPage,
                'aca-btn-primary': isAcaPage && isMiniEnvLandingPage,
                'scroled-aca-btn-primary': isAcaPage  && !isMiniEnvLandingPage

              }">
            {{ config.primaryButtonText }}
          </a>
        </li>
        }
        } @else {
        <li class="nav-item topbar-btn">
          <a [routerLink]="routes.dashboard" class="btn btn-primary mobile-dashboard-btn" style="margin-right: 4px;">
            Go to Dashboard &nbsp;
            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
              <path d="M10.2505 9.20286L16.4005 3.05286" stroke="white" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M17.0004 6.05288V2.45288H13.4004" stroke="white" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M8.75049 2.45288H7.25049C3.50049 2.45288 2.00049 3.95288 2.00049 7.70288V12.2029C2.00049 15.9529 3.50049 17.4529 7.25049 17.4529H11.7505C15.5005 17.4529 17.0005 15.9529 17.0005 12.2029V10.7029"
                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg> -->


          </a>
        </li>
        <li class="nav-item topbar-btn">
          <a (click)="helperService.logoutFlow()" class="btn mobile-logout-btn">Logout</a>
        </li>
        }
      </ul>
    </div>
    }



  </div>
</nav>

<!-- <app-warning-block
        *ngIf="showFutureServiceErr"
        [heading]="('MEMBERSHIP_WARNING' | translate)"
        [message]="errMsg" (hideAction)="hideError($event)" 
        [containerStyle]="containerStyle" [msgBodyStyle]="msgBodyStyle"></app-warning-block> -->